import React from 'react';
import { Route } from 'react-router-dom';
import Privacy from './Privacy';

const routes = [
  <Route key="privacy" path="/privacy"><Privacy/></Route>
];

export default routes;
